import { render, staticRenderFns } from "./PeriodItem.vue?vue&type=template&id=c600f298&scoped=true&"
import script from "./PeriodItem.vue?vue&type=script&lang=js&"
export * from "./PeriodItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c600f298",
  null
  
)

export default component.exports